import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / brand" stethoscope.
export const Stethoscope = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.81206 2.92308C2.65962 2.92308 2.55385 3.04327 2.55385 3.16266V4.5766C2.55385 6.36069 3.94773 7.78428 5.61906 7.78428C7.29039 7.78428 8.68427 6.36069 8.68427 4.5766H9.60734C9.60734 6.83566 7.83434 8.70736 5.61906 8.70736C3.40377 8.70736 1.63078 6.83566 1.63078 4.5766V3.16266C1.63078 2.51082 2.17278 2 2.81206 2H4.0956V2.92308H2.81206Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.14173 2H8.42527C9.06455 2 9.60655 2.51082 9.60655 3.16266V4.5766H8.68347V3.16266C8.68347 3.04327 8.57771 2.92308 8.42527 2.92308H7.14173V2Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.04483 10.3133C6.04483 11.8349 7.30219 13.0769 8.89411 13.0769C10.4849 13.0769 11.7434 11.8243 11.7434 10.3133H12.6665C12.6665 12.3546 10.974 14 8.89411 14C6.81534 14 5.12175 12.3674 5.12175 10.3133H6.04483Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.12175 10.5237V8.24506H6.04483V10.5237H5.12175Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2043 7.45712C11.507 7.45712 10.9624 8.00472 10.9624 8.65491C10.9624 9.3051 11.507 9.8527 12.2043 9.8527C12.9016 9.8527 13.4461 9.3051 13.4461 8.65491C13.4461 8.00472 12.9016 7.45712 12.2043 7.45712ZM10.0394 8.65491C10.0394 7.47226 11.0201 6.53404 12.2043 6.53404C13.3885 6.53404 14.3692 7.47226 14.3692 8.65491C14.3692 9.83756 13.3885 10.7758 12.2043 10.7758C11.0201 10.7758 10.0394 9.83756 10.0394 8.65491Z"
    />
  </svg>
);
